export const pathPatternToRegex = (pattern: string): RegExp => {
  const escaped = pattern
    .replace(/[.+?^${}()|[\]\\]/g, '\\$&') // escape special regex chars (but not *)
    .replace(/\*/g, '.*') // convert * to .*
  return new RegExp(`^${escaped}$`)
}
